import { company } from '~/company/Company';
import type { CloudflareResizeOptions } from '~/components/CloudflareResponsiveImage/CloudflareResizeOptions';
import { FALLBACK_IMAGE_WIDTH } from '~/components/CloudflareResponsiveImage/constants';
import {
  getCloudflareDomain,
  getCloudflareUrl,
} from '~/components/CloudflareResponsiveImage/utils';

export const createCategoryUrl = ({ id }: { id: number | string }) => {
  return company.match({
    mcosmetic: `/c/${id}?showProducts=true`,
    default: `/c/${id}`,
  });
};

export const createProductUrl = ({ id }: { id: number | string }) => `/p/${id}`;

/**
 * Builds a CDN URL for a category/product image on the current tenant's domain.
 *
 * `size` may be omitted, but it is never forwarded as-is: without a resize
 * option `getCloudflareUrl` returns the raw origin URL, so such a caller would
 * silently bypass the CDN and ship the full-size upload. Heimkaup requests
 * everything at 2x density, so callers must pass CSS pixel sizes rather than
 * pre-multiplying them.
 */
export const cfSrcForImage = (src: string, size?: CloudflareResizeOptions) => {
  const requestedSize: CloudflareResizeOptions = size ?? {
    fit: 'contain',
    width: FALLBACK_IMAGE_WIDTH,
  };

  const options = company.match({
    heimkaup: { dpr: 2, ...requestedSize },
    default: requestedSize,
  });

  return getCloudflareUrl(src, getCloudflareDomain(), options);
};
